import React, { useEffect, useState } from "react";
import SimilarityIndicator from "./SimilarityIndicator";
import Hat from "../../../../../../Assets/Images/CandidateItemIcons/Hat.svg";
import Path from "../../../../../../Assets/Images/CandidateItemIcons/Path.svg";
import ContactInfo from "./ContactInfo";
import SkillsModal from "./SkillsModal";
import DeleteCandidateModal from "./DeleteCandidateModal";
import { Config } from "../../../../../../Config";
import axios from "axios";
import { NavLink } from "react-router-dom";

const CandidateItem = (props) => {
  const [ContactInfoIsOpen, setContactInfoIsOpen] = useState(false);
  const [SkillsModalIsOpen, setSkillsModalIsOpen] = useState(false);
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);
  const [DeleteCandidateIsOpen, setDeleteCandidateIsOpen] = useState(false);
  const [IsChecked, setIsChecked] = useState(false);

  useEffect(() => {
    window.localStorage.removeItem("chat_jpaId");
    window.localStorage.removeItem("chat_recipientId");
    window.localStorage.removeItem("chat_workCiy");
    window.localStorage.removeItem("chat_title");
    window.localStorage.removeItem("chat_jpaType");
    window.localStorage.removeItem("chat_source");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const swapTab = (TabName) => {
    if (TabName === "main") {
      // adding active state to the selected tab icon
      document
        .getElementById(props.Data.candidate.id + "-main")
        .classList.add("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-path")
        .classList.remove("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-skills")
        .classList.remove("active-tab-item");
      // transforming the indicator line at the bottom of the tabs
      document.getElementById(
        props.Data.candidate.id + "-tab-indicator"
      ).style.transform = "unset";
      // displaying the selected tab content
      document
        .getElementById(props.Data.candidate.id + "-tab-1")
        .classList.remove("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-1")
        .classList.add("fade-in");
      setTimeout(() => {
        //removing the animation classname to prevent style conflicts
        document
          .getElementById(props.Data.candidate.id + "-tab-1")
          .classList.remove("fade-in");
      }, 450);
      document
        .getElementById(props.Data.candidate.id + "-tab-2")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-3")
        .classList.add("hidden");
    } else if (TabName === "skills") {
      // adding active state to the selected tab icon
      document
        .getElementById(props.Data.candidate.id + "-main")
        .classList.remove("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-skills")
        .classList.add("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-path")
        .classList.remove("active-tab-item");
      // transforming the indicator line at the bottom of the tabs
      document.getElementById(
        props.Data.candidate.id + "-tab-indicator"
      ).style.transform = "translateX(56px)";
      // displaying the selected tab content
      document
        .getElementById(props.Data.candidate.id + "-tab-2")
        .classList.remove("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-2")
        .classList.add("fade-in");
      setTimeout(() => {
        //removing the animation classname to prevent style conflicts
        document
          .getElementById(props.Data.candidate.id + "-tab-2")
          .classList.remove("fade-in");
      }, 450);
      document
        .getElementById(props.Data.candidate.id + "-tab-1")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-3")
        .classList.add("hidden");
    } else if (TabName === "path") {
      // adding active state to the selected tab icon
      document
        .getElementById(props.Data.candidate.id + "-main")
        .classList.remove("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-path")
        .classList.add("active-tab-item");
      document
        .getElementById(props.Data.candidate.id + "-skills")
        .classList.remove("active-tab-item");
      // transforming the indicator line at the bottom of the tabs
      document.getElementById(
        props.Data.candidate.id + "-tab-indicator"
      ).style.transform = "translateX(110px)";
      // displaying the selected tab content
      document
        .getElementById(props.Data.candidate.id + "-tab-3")
        .classList.remove("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-3")
        .classList.add("fade-in");
      setTimeout(() => {
        //removing the animation classname to prevent style conflicts
        document
          .getElementById(props.Data.candidate.id + "-tab-3")
          .classList.remove("fade-in");
      }, 450);
      document
        .getElementById(props.Data.candidate.id + "-tab-2")
        .classList.add("hidden");
      document
        .getElementById(props.Data.candidate.id + "-tab-1")
        .classList.add("hidden");
    }
  };
  const selectSkillToDisplay = (Skills) => {
    let ShortSkills = [];
    Skills.map((Skill) => {
      if (Skill !== null && Skill.title.length < 33) {
        ShortSkills.push(Skill.title);
      }
    });
    if (ShortSkills.length > 0) {
      return ShortSkills[0];
    } else {
      Skills.map((Skill) => {
        if (Skill !== null) {
          ShortSkills.push(Skill.title);
        }
      });
    }
  };
  const displayPathItems = (Candidate) => {
    if (Candidate.path !== null) {
      let Paths = Candidate.path.split(",");
      var Path1 = Paths[0];
      var Path2 = Paths[1];

      if (Path1 === "income") {
        Path1 = "Improve Income";
      } else if (Path1 === "career") {
        Path1 = "Next level career";
      } else if (Path1 === "skills") {
        Path1 = "Improve Skills";
      } else if (Path1 === "projects") {
        Path1 = "Cool projects";
      }
      if (Path2 === "income") {
        Path2 = "Improve Income";
      } else if (Path2 === "career") {
        Path2 = "Next level career";
      } else if (Path2 === "skills") {
        Path2 = "Improve Skills";
      } else if (Path2 === "projects") {
        Path2 = "Cool projects";
      }
      return (
        <React.Fragment>
          {Path1 !== undefined ? (
            <span className="path-item">{Path1}</span>
          ) : null}
          {Path2 !== undefined ? (
            <span className="path-item">{Path2}</span>
          ) : null}
        </React.Fragment>
      );
    } else {
      return (
        <p className="non-margined-not-available">
          {translateText("not_available")}
        </p>
      );
    }
  };
  const displayLanguages = () => {
    let CandidateLanguages = [];

    props.Data.candidate.language.map((Lang) => {
      CandidateLanguages.push(Lang.name);
    });
    return CandidateLanguages.toString();
  };
  const handleSkills = () => {
    let Skills = [];
    props.Data.candidate.topSkills.map((Skill) => {
      Skills.push(Skill.title);
    });
    return Skills;
  };
  const handleCandidateIdentityDisplay = () => {
    if (props.Data.candidate.lastName === null) {
      return "Anonymous";
    } else {
      return (
        props.Data.candidate.firstName + " " + props.Data.candidate.lastName
      );
    }
  };
  const toggleVerifyDeleteCandidate = () => {
    setContextMenuIsOpen(false);
    setDeleteCandidateIsOpen(true);
  };
  const toggleBookmark = () => {
    if (
      document
        .getElementById(props.Data.candidate.id + "-bookmark")
        .classList.contains("bookmarked") ||
      document
        .getElementById(props.Data.candidate.id + "-bookmark")
        .classList.contains("bookmarked-animated")
    ) {
      document
        .getElementById(props.Data.candidate.id + "-bookmark")
        .classList.remove("bookmarked-animated");
      document
        .getElementById(props.Data.candidate.id + "-bookmark")
        .classList.remove("bookmarked-animated");
    } else {
      document
        .getElementById(props.Data.candidate.id + "-bookmark")
        .classList.add("bookmarked-animated");
    }
    let ReqURL;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    }
    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        candidateId: props.Data.candidate.id,
      },
    };
    axios(Req)
      .then((Res) => {
        props.RefreshData(Res.data.candidate.id, Res.data.bookmarked);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const displayPositionText = () => {
    if (
      props.Data.candidate.currentPositionTitle !== null &&
      props.Data.candidate.currentPositionTitle.length < 27
    ) {
      return <p>{props.Data.candidate.currentPositionTitle}</p>;
    } else if (props.Data.candidate.currentPositionTitle !== null) {
      return (
        <p>
          {props.Data.candidate.currentPositionTitle.slice(0, 27) + " ..."}
          <p className="popup-text">
            {props.Data.candidate.currentPositionTitle}
          </p>
        </p>
      );
    } else {
      return null;
    }
  };
  const toggleChat = () => {
    let JPAId = props.JPA.id;
    let JPAType;
    if (props.IsJob) {
      JPAType = "position";
    } else if (props.IsProject) {
      JPAType = "project";
    } else {
      JPAType = "activity";
    }
    window.localStorage.setItem("chat_jpaId", JPAId);
    window.localStorage.setItem("chat_recipientId", props.Data.candidate.id);
    window.localStorage.setItem("chat_workCiy", props.JPA.workCity);
    window.localStorage.setItem("chat_title", props.JPA.title);
    window.localStorage.setItem("chat_jpaType", JPAType);
    window.localStorage.setItem("chat_source", "CANDIDATE");

    setTimeout(() => {
      document.getElementById("communication-toggle").click();
    }, 200);
  };
  const displayHigherEducation = () => {
    let Education =
      props.Data.candidate.higherEducation.major +
      ", " +
      props.Data.candidate.higherEducation.degree;
    if (Education.length <= 34) {
      if (window.innerWidth <= 1024 && window.innerWidth >= 600) {
        Education =
          Education.length <= 28 ? Education : Education.slice(0, 25) + "...";
      }
      return <p className="tab-info">{Education}</p>;
    } else {
      let Shortened = Education.slice(0, 30) + "...";
      if (window.innerWidth <= 1024 && window.innerWidth >= 600)
        Shortened = Education.slice(0, 25) + "...";
      return (
        <p className="tab-info">
          {Shortened}
          <p className="popup-text">{Education}</p>
        </p>
      );
    }
  };

  const handleCheckItem = () => {
    // setIsChecked(!IsChecked);

    if (IsChecked) {
      // is inactive
      setIsChecked(!IsChecked);
      props.RemoveCandidateId(props.Data.candidate.id);
    } else {
      // is active
      if (props.TotalCheckedCount < 10) {
        setIsChecked(!IsChecked);
        props.AddCandidateId(props.Data.candidate.id);
      }
    }
  };

  return (
    <div className="candidate">
      <span
        className={
          IsChecked ? "icon-checkbox icon-checkbox-active" : "icon-checkbox"
        }
        id={props.Data.candidate.id + "-checkbox"}
        onClick={() => handleCheckItem()}
      >
        <p className="popup">{translateText("compare")}</p>
      </span>
      <NavLink hidden to="/communication" id="communication-toggle"></NavLink>
      {DeleteCandidateIsOpen ? (
        <DeleteCandidateModal
          Close={() => setDeleteCandidateIsOpen(false)}
          LangData={props.LangData}
          Title={props.JPA.title}
        />
      ) : null}
      {ContactInfoIsOpen ? (
        <ContactInfo
          Close={() => setContactInfoIsOpen(false)}
          Candidate={props.Data.candidate}
          LangData={props.LangData}
        />
      ) : null}
      {SkillsModalIsOpen ? (
        <SkillsModal
          Close={() => setSkillsModalIsOpen(false)}
          Skills={handleSkills()}
          Title={handleCandidateIdentityDisplay()}
          Location={props.Data.candidate.currentPositionTitle}
          IsCandidateSkills={true}
          LangData={props.LangData}
        />
      ) : null}
      <section className="candidate-head">
        <i
          className="feather-more-vertical"
          onClick={() => setContextMenuIsOpen(true)}
        ></i>
        {ContextMenuIsOpen ? (
          <React.Fragment>
            <div
              className="outline"
              onClick={() => setContextMenuIsOpen(false)}
            ></div>
            <div className="candidate-context-menu">
              <section
                className="menu-row red-item"
                onClick={() => toggleVerifyDeleteCandidate()}
              >
                <i className="feather-trash-2"></i>
                <p>{translateText("jpa_actions_delete_candidate")}</p>
              </section>
            </div>
          </React.Fragment>
        ) : null}
        {props.Data.bookmarked ? (
          <button
            className="bookmark-btn bookmarked"
            id={props.Data.candidate.id + "-bookmark"}
            onClick={() => toggleBookmark()}
          >
            <p className="popup">{translateText("unsave")}</p>
          </button>
        ) : (
          <button
            className="bookmark-btn"
            id={props.Data.candidate.id + "-bookmark"}
            onClick={() => toggleBookmark()}
          >
            <p className="popup">{translateText("save")}</p>
          </button>
        )}
        <button
          onClick={() => toggleChat()}
          className="communication-connector"
        >
          <p className="popup-text">{translateText("chat")}</p>
        </button>
      </section>
      <section className="avatar-holder">
        {props.Data.candidate.imageThumbnailUrl === null ? (
          <div
            className="avatar-placeholder"
            style={{
              backgroundColor: props.Data.candidate.backgroundColorCode,
              color: props.Data.candidate.textColorCode,
            }}
          >
            {props.Data.candidate.firstName.slice(0, 1).toUpperCase() +
              props.Data.candidate.lastName.slice(0, 1).toUpperCase()}
          </div>
        ) : (
          <img
            className="avatar-image"
            src={props.Data.candidate.imageThumbnailUrl}
          />
        )}
        <div className="candidate-identity">
          <h1>
            {props.Data.candidate.firstName +
              " " +
              props.Data.candidate.lastName}
          </h1>
          {displayPositionText()}
        </div>
      </section>
      <section className="candidate-tabs">
        <span className="tab-item" onClick={() => swapTab("main")}>
          <i
            id={props.Data.candidate.id + "-main"}
            className="feather-briefcase active-tab-item"
          ></i>
        </span>
        <span className="tab-item" onClick={() => swapTab("skills")}>
          <i
            id={props.Data.candidate.id + "-skills"}
            className="feather-star"
          ></i>
        </span>
        <span className="tab-item" onClick={() => swapTab("path")}>
          <i
            id={props.Data.candidate.id + "-path"}
            className="feather-flag"
          ></i>
        </span>
        <span
          id={props.Data.candidate.id + "-tab-indicator"}
          className="tab-indicator"
        ></span>
      </section>
      <div className="tab-content">
        <div className="tab-1" id={props.Data.candidate.id + "-tab-1"}>
          <SimilarityIndicator Percentage={props.Data.candidate.similarity} />
          <section className="candidate-actions">
            <span
              className="outline-btn"
              onClick={() => setContactInfoIsOpen(true)}
            >
              {translateText("contact_info")}
            </span>
          </section>
        </div>
        <div className="tab-2 hidden" id={props.Data.candidate.id + "-tab-2"}>
          <div className="iconed-row">
            <i className="feather-star"></i>
            <section className="row-content">
              <p className="row-label">{translateText("top_skills")}</p>
              <section className="skills">
                {props.Data.candidate.topSkills.length > 0 ? (
                  <React.Fragment>
                    <span className="skill-item">
                      {selectSkillToDisplay(props.Data.candidate.topSkills)}
                    </span>
                    <span
                      className="more-skills"
                      onClick={() => setSkillsModalIsOpen(true)}
                    >
                      <i className="feather-more-vertical"></i>
                    </span>
                  </React.Fragment>
                ) : (
                  <p className="non-margined-not-available">
                    {translateText("not_available")}
                  </p>
                )}
              </section>
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-award"></i>
            <section className="row-content">
              <p className="row-label">
                {translateText("years_of_experience")}
              </p>
              {props.Data.candidate.yearsOfExperience !== null ||
              (props.Data.candidate.yearsOfExperience &&
                props.Data.candidate.yearsOfExperience.length !== 0) ? (
                <p className="tab-info">
                  {props.Data.candidate.yearsOfExperience}
                </p>
              ) : (
                <p className="not-available">
                  {translateText("not_available")}
                </p>
              )}
            </section>
          </div>
          <div className="iconed-row">
            <img src={Hat} />
            <section className="row-content">
              <section className="row-content">
                <p className="row-label">{translateText("higher_education")}</p>
                {props.Data.candidate.higherEducation !== null ? (
                  <React.Fragment>{displayHigherEducation()}</React.Fragment>
                ) : (
                  <p className="not-available">
                    {translateText("not_available")}
                  </p>
                )}
              </section>
            </section>
          </div>
        </div>
        <div className="tab-3 hidden" id={props.Data.candidate.id + "-tab-3"}>
          <div className="iconed-row">
            <img src={Path} />
            <section className="row-content">
              <p className="row-label">{translateText("wizard_your_path")}</p>
              <section className="skills paths">
                {displayPathItems(props.Data.candidate)}
              </section>
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-globe"></i>
            <section className="row-content">
              <p className="row-label">{translateText("language")}</p>
              {props.Data.candidate.language.length === 0 ? (
                <p className="not-available">
                  {translateText("not_available")}
                </p>
              ) : (
                <p className="tab-info">{displayLanguages()}</p>
              )}
            </section>
          </div>
          <div className="iconed-row">
            <i className="feather-map-pin"></i>
            <section className="row-content">
              <section className="row-content">
                <p className="row-label">{translateText("home_city")}</p>
                {props.Data.candidate.homeCity !== null ? (
                  <p className="tab-info">{props.Data.candidate.homeCity}</p>
                ) : (
                  <p className="not-available">
                    {translateText("not_available")}
                  </p>
                )}
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateItem;
